import { FC, ReactElement, useEffect, useState, useRef, MutableRefObject, HTMLAttributes, FormEvent } from "react";
import CardContent from "@mui/material/CardContent";
import { Card, CardHeader } from "../Form.Status/Status.styled";
import CloseIcon from "../../assets/CloseIcon.svg";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import { CardContainer, Label2, SavedCards } from "../MoveOutTerminationTabs/MoveOut.styled";
import visa from "../../assets/visa.svg";
import CC from "../../assets/card2.svg";
import amex from "../../assets/amex.svg";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import General from '../../stores/GeneralStore'

import { Frames, CardNumber, ExpiryDate, Cvv } from 'frames-react';

import CardsStore from "../../stores/CardsStore";
import { observer } from "mobx-react";
import { SpinnerRaw } from "../SpinnerRaw/SpinnerRaw";
interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  onClose?: React.MouseEventHandler<HTMLImageElement>;
  saveAccounts: (data:any) => void;
  datValue:any;
  loader:Boolean;
}

const AmountEdit: FC<Props> = ({
  onClose,
  saveAccounts,
  datValue,
  loader,
}: Props): ReactElement => {
    const dateInput = useRef<HTMLSelectElement | null>(null);
  const handleSave = () => {
    const data={
      paymentDate:dateInput?.current?.value,
      accountId:datValue?.account?.accountNo,
      sourceId:datValue?.card?.sourceId,
      previousPaymentId:datValue?.card?.previousPaymentId,
      expiryYear:datValue?.card?.expiryYear,
      expiryMonth:datValue?.card?.expiryMonth,
      cardType:datValue?.card?.cardType,
      cardNumber:datValue?.card?.cardNumber,
      gatewayCdField: datValue?.card?.gatewayCdField,
    }
    saveAccounts(data);
  }
  const [value, setValue] = useState(datValue?.account?.paymentDate);

  const handleInputChange = (event:any) => {
    const inputValue = event.target.value;
    // Check if the entered value is less than or equal to 28
    if (inputValue <= 28) {
      setValue(inputValue);
    }
  };

  useEffect(() => {
  }, [])

  return (

    <Card style={{ overflow: 'auto', margin: "auto", width:General?.isLargeScreen? "35vw":"100%", height: "30vh", color: '#101e8e', display: "flex", backgroundColor: "white", alignItems: "center", justifyContent: "center", marginTop: "30px" }}>
      {onClose
        ? <CardHeader
          style={{
            width: "100%",
            height: "9vh",
            display: "flex",
            background: General?.colorClass? General?.colorClass:""
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", width: "95%" }}>


            <h1 style={{ color: "#fff", justifySelf: "flex-start", fontSize: `${2 * General.accessibility.fontSize}rem` }}>
              {General?.codeLabels["cm_paymentdatedatatable"]?.label !== undefined ? General?.codeLabels["cm_paymentdatedatatable"]?.label : "Payment Date"}
            </h1>
            <img src={CloseIcon} alt="" onClick={onClose} />
          </div>
        </CardHeader >
        : null}

      <CardContent sx={{ background: "#fff", width: '100%', height: "25vh", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

        {/* <input value={value} style={{width:'30vw',height:'45px'}} type="number" max={28} onChange={handleInputChange} ref={dateInput}/> */}
        <select
                className={General?.textClass}
                  style={{
                    color: "#101E8E",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    width:'60%',
                    height:'48px',
                  }}
                  ref={dateInput}
                  // ref={genderValue}
                  onChange={handleInputChange}
                >
                  <option disabled selected>
                    {General?.codeLabels['cm_pdc_select']?.label?General?.codeLabels['cm_pdc_select']?.label:"Select"}
                  </option>
                    {
                      [...Array(28).keys()].map((num:any)=>
                      <option key={num + 1}
                      value={num + 1}>
                          {num + 1}
                      </option>
                      )
                    }
                </select>
        <ButtonsContainer style={{ justifyContent: 'end', width: '30%', height: "9vh",  }}>

          <ButtonSecondary
            style={{
              width: "12rem",
              padding: "auto",
              color: "#fff",
              background: "#101e8e",
              fontWeight: 'bold',
              fontSize: `${General.accessibility.fontSize}rem`
            }}
            onClick={handleSave}
            className={General?.colorClass}
          >
            {loader?<SpinnerRaw width={30} height={30}/>: General?.codeLabels["cm_save"]?.label?General?.codeLabels["cm_save"]?.label:"save"}
          </ButtonSecondary>
        </ButtonsContainer>

      </CardContent >
    </Card >
  );
};

export default observer(AmountEdit);
